module.exports = __webpack_public_path__ + "img/68.10.pH.6f165d5f.png";